import { render, staticRenderFns } from "./TeacherMypage.vue?vue&type=template&id=246bf1ec&scoped=true&"
import script from "./TeacherMypage.vue?vue&type=script&lang=js&"
export * from "./TeacherMypage.vue?vue&type=script&lang=js&"
import style0 from "./TeacherMypage.vue?vue&type=style&index=0&id=246bf1ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246bf1ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFileInput,VRow})
